/** @format */

import React from 'react';
import {
    PRODUCT_TYPE_CARTON,
    PRODUCT_TYPE_GRAPHIC_DESIGN,
    PRODUCT_TYPE_LABEL
} from 'frontier-constants';
import {prettyProductSize} from 'frontier/ds/quoter/functions/format';
import {prettyProductShape} from '../../../../ds/quoter/functions/format';

export const OrderDisplayMeta = ({props}) => {
    const {product_type_id, graphic_design_order_details, shape_id, size_description, shape_label} =
        props;

    // most product types differ in the meta we display in the UI for them. Check what product_type_id we are accounting for
    const isLabel = product_type_id === PRODUCT_TYPE_LABEL;
    const isLabelOrCarton =
        product_type_id === PRODUCT_TYPE_LABEL || product_type_id === PRODUCT_TYPE_CARTON;
    const isCustomDesign =
        product_type_id === PRODUCT_TYPE_GRAPHIC_DESIGN &&
        graphic_design_order_details.design_type_id === 3;

    // get shape and corner shape
    const shape = prettyProductShape(shape_label, props?.is_square_corners, shape_id);

    // get style (style property does not exist in all custom designs)
    let style;
    if (product_type_id === PRODUCT_TYPE_GRAPHIC_DESIGN) {
        style = graphic_design_order_details.design_style_preferences_label;
        style = style !== '' && style !== undefined ? style : 'N/A';
    }
    return (
        <div className="display-metadata">
            {isLabelOrCarton && (
                <>
                    {isLabel && (
                        <p className="p-0 product_desc-meta">
                            <span>Shape:</span> {shape}
                        </p>
                    )}
                    <p className="p-0 product_desc-meta">
                        <span>Material:</span>{' '}
                        {props.substrate_label.replace('Carton', '').replace('Label', '')}
                    </p>
                    <p className="p-0 product_desc-meta">
                        <span>Laminate:</span> {props.laminate_label}
                    </p>
                    {isLabel && (
                        <p className="p-0 product_desc-meta tw-ml-2">
                            <span>Backing:</span> {props.backing_label}
                        </p>
                    )}
                </>
            )}

            {!isCustomDesign && !isLabelOrCarton && (
                <>
                    <p className="p-0 product_desc-meta">
                        <span>Size:</span>{' '}
                        {prettyProductSize(
                            size_description,
                            product_type_id,
                            graphic_design_order_details.design_product_type_id
                        )}
                    </p>
                    <p className="p-0 product_desc-meta">
                        <span>Shape:</span> {shape}
                    </p>
                </>
            )}
            {isCustomDesign && (
                <>
                    <div className="m-0 tw-p-0">
                        <p className="p-0 product_desc-meta">
                            <span>Size:</span>{' '}
                            {prettyProductSize(
                                size_description,
                                product_type_id,
                                graphic_design_order_details.design_product_type_id
                            )}
                        </p>
                        <p className="p-0 product_desc-meta">
                            <span>Shape:</span> {shape}
                        </p>
                    </div>
                    <div className="m-0 tw-p-0">
                        <p className="p-0 product_desc-meta">
                            <span>Color:</span>{' '}
                            {graphic_design_order_details?.color_preferences_label}
                        </p>
                        <p className="p-0 product_desc-meta">
                            <span>Style:</span> {style}
                        </p>
                    </div>
                </>
            )}
        </div>
    );
};
